import {request} from '../jslib/request'
const BASE_REQUEST = '/tms/carLine'

export function getCarLineInfo(info) {
  return request({
    url: `${BASE_REQUEST}/getCarLineInfo`,
    method: 'get',
    data: info
  })
}
export function defaultShowCarLineInfo(info) {
  return request({
    url: `${BASE_REQUEST}/defaultShowCarLineInfo`,
    method: 'get',
    data: info
  })
}
export function saveOrUpdateCarLine(info) {
  return request({
    url: `${BASE_REQUEST}/saveOrUpdateCarLine`,
    method: 'post',
    data: info
  })
}
export function daiguazhang(data) {
  return request({
    url:`${BASE_REQUEST}/daiguazhang`,
    data:data
  })
}
export function chehuiToUpdate(data) {
  return request({
    url:`${BASE_REQUEST}/chehuiToUpdate`,
    data:data
  })
}
export function genVoyageNumber(linetype) {
  return request({
    url:`${BASE_REQUEST}/genVoyageNumber`,
    data:{linetype: linetype}
  })
}
export function getWuLiuYeWuYuan(data) {
  return request({
    url:`${BASE_REQUEST}/getWuLiuYeWuYuan`,
    data:data
  })
}
export function getCarLineStowage(where) {
  return request({
    url: `${BASE_REQUEST}/getCarLineStowage`,
    method: 'get',
    data: where
  })
}
export function delCarLineInfo(where) {
  return request({
    url: `${BASE_REQUEST}/delCarLineInfo`,
    method: 'get',
    data: where
  })
}
export function getCarLineIntegrationInfo(where) {
  return request({
    url: `${BASE_REQUEST}/getCarLineIntegrationInfo`,
    method: 'get',
    data: where
  })
}
export function postCarLineDataSucc(where) {
  return request({
    url: `${BASE_REQUEST}/postCarLineDataSucc`,
    method: 'get',
    data: where
  })
}
export function getCarLineZiYou(data) {
  return request({
    url: `${BASE_REQUEST}/getCarLineZiYou`,
    method: 'get',
    data: data
  })
}
//流向
export function saveOrUpdateCarLineFlow(info) {
  return request({
    url: `${BASE_REQUEST}/saveOrUpdateCarLineFlow`,
    method: 'post',
    data: info
  })
}
export function getCarFlowByList(where) {
  return request({
    url: `${BASE_REQUEST}/getCarFlowByList`,
    method: 'get',
    data: where
  })
}
export function getCarFlowInfo(where) {
  return request({
    url: `${BASE_REQUEST}/getCarFlowInfo`,
    method: 'get',
    data: where
  })
}
export function getCarFlowDindJinList(where) {
  return request({
    url: `${BASE_REQUEST}/getCarFlowDindJinList`,
    method: 'get',
    data: where
  })
}
export function updateCarApplyStatus(data) {
  return request({
    url: `${BASE_REQUEST}/updateCarApplyStatus`,
    data: data
  })
}
export function getCarFlowDingjingById(where) {
  return request({
    url: `${BASE_REQUEST}/getCarFlowDingjingById`,
    method: 'get',
    data: where
  })
}
export function delCarFlowInfo(where) {
  return request({
    url: `${BASE_REQUEST}/delCarFlowInfo`,
    method: 'get',
    data: where
  })
}
export function postCarFlowDataSucc(where) {
  return request({
    url: `${BASE_REQUEST}/postCarFlowDataSucc`,
    method: 'get',
    data: where
  })
}
export function getCarContractImages(where) {
  return request({
    url: `${BASE_REQUEST}/getCarContractImages`,
    method: 'get',
    data: where
  })
}


//车次
export function saveOrUpdateCarLineBatch(info) {
  return request({
    url: `${BASE_REQUEST}/saveOrUpdateCarLineBatch`,
    method: 'post',
    data: info
  })
}
export function getCarBatchByCarLineId(where) {
  return request({
    url: `${BASE_REQUEST}/getCarBatchByCarLineId`,
    method: 'get',
    data: where
  })
}
export function getCarBatchInfo(where) {
  return request({
    url: `${BASE_REQUEST}/getCarBatchInfo`,
    method: 'get',
    data: where
  })
}
export function delCarBatchInfo(where) {
  return request({
    url: `${BASE_REQUEST}/delCarBatchInfo`,
    method: 'get',
    data: where
  })
}
export function carStatistics(where) {
  return request({
    url: `${BASE_REQUEST}/carStatistics`,
    method: 'get',
    data: where
  })
}

